import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from "./Icon";
/**
 * ReorderIcon - A reorder/swap icon with arrows pointing left and right
 */
export const ReorderIcon = ({ size = 16, color = "#6B7280", className = "", ...props }) => {
    return (_jsx(Icon, { size: size, color: color, viewBox: "0 0 16 16", className: className, ...props, children: _jsx("path", { d: "M5.33333 2.66667L2.66667 5.33333M2.66667 5.33333L5.33333 8M2.66667 5.33333H13.3333M10.6667 13.3333L13.3333 10.6667M13.3333 10.6667L10.6667 8M13.3333 10.6667H2.66667", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));
};
